global.BaseUrl = "https://api.foodweb-test.ksoftpl.com/api";
global.AssetsUrl = "https://api.foodweb-test.ksoftpl.com";
// global.BaseUrl = "https://foodweb-impala.ksoftpl.com/foodweb-ifc-backend/public/api";
// global.AssetsUrl = "https://foodweb-impala.ksoftpl.com/foodweb-ifc-backend/public";